import { storeToRefs } from 'pinia'
import pinia from '@/store/pinia'
import useAuthStore from '@/store/auth'

const auth = [
  {
    path: '/',
    name: 'index',
    redirect: to => {
      const { possuiAccessTokenDefinido } = storeToRefs(useAuthStore(pinia))

      if (possuiAccessTokenDefinido.value) {
        return { name: 'front-atendimento' }
      }

      return { name: 'auth-login', query: to.query }
    }
    ,
  },
  {
    path: '/error-404',
    name: 'auth-error-404',
    component: () => import('@/pages/error404/Error404.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/sucesso',
    name: 'auth-success',
    component: () => import('@/pages/success/Success.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/pages/login/Login.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/cadastro',
    name: 'auth-register',
    component: () => import('@/pages/register/Register.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/solicitar-troca-senha',
    name: 'auth-solicitar-troca-senha',
    component: () => import('@/pages/trocar-senha/EsqueciMinhaSenha.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/resetar-senha',
    name: 'auth-resetar-senha',
    component: () => import('@/pages/trocar-senha/RedefinirSenha.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/auth/microsoft-callback',
    name: 'auth-code-flow-callback',
    component: () => import('@/components/auth/AuthorizationCodeFlowAuthCallback.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/verificacao-mfa',
    name: 'auth-mfa',
    component: () => import('@/pages/login/TwoFactorAuthentication.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },
]

export default auth
